import type { License } from "@/types/api";
import { cn } from "@/utils/utils";
import { ReactComponent as Check } from "@/assets/icons/Check.svg";

type LicenseRedemptionRowSuccessProps = {
  license: License;
} & React.HTMLAttributes<HTMLDivElement>;

export const LicenseRedemptionRowSuccess: React.FC<LicenseRedemptionRowSuccessProps> = ({
  license,
  className,
  ...divProps
}) => {
  return (
    <div className={cn("w-full p-3", className)} {...divProps}>
      <p className="font-bold text-xs">{license.productName}</p>
      <div className="flex flex-row space-x-1">
        <Check className="size-4" />
        <p className="text-xs font-semibold" style={{ color: "var(--musio-green)" }}>Added</p>
      </div>
    </div>
  );
};
